import { Component, computed } from '@angular/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  datepicker,
  DynamicFormField,
  formBuilder,
} from '@kinet-open-network/client/core/forms/ui';
import { IAutomationActionWriteBottleOwnersToOnixData } from '@kinet-open-network/shared/data-access/model-pbgas';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'kon-write-bottle-owners-to-onix-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class WriteBottleOwnersToOnixActionComponent extends ActionComponent<'write-bottle-owners-to-onix'> {
  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([datepicker('date', 'Dátum')]),
  );

  override dataToModel(
    data: Partial<IAutomationActionWriteBottleOwnersToOnixData>,
  ) {
    return {
      date: data.date ? new Date(data.date) : undefined,
    };
  }
}
